









































import Vue, { VueConstructor } from 'vue';

export interface SelectedData {
  key: string;
  value: string;
  path: string;
}

export interface Data {
  [key: string]: string;
}

export default Vue.extend({
  name: 'json-view-item',
  data: function() {
    return {
      open: this.data.depth < this.maxDepth
    };
  },
  props: {
    data: {
      required: true,
      type: Object
    },
    maxDepth: {
      type: Number,
      required: false,
      default: 1
    },
    canSelect: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    toggleOpen: function(): void {
      this.open = !this.open;
    },
    clickEvent: function(data: Data): void {
      this.$emit('selected', {
        key: data.key,
        value: data.value,
        path: data.path
      } as SelectedData);
    },
    bubbleSelected: function(data: Data): void {
      this.$emit('selected', data);
    },
    getKey: function(value: any): string {
      if (!isNaN(value.key)) {
        return value.key + ':';
      } else {
        return '"' + value.key + '":';
      }
    },
    getValueStyle: function(value: any): object {
      const type = typeof value;
      switch (type) {
        case 'string':
          return { color: 'var(--vjc-string-color)' };
        case 'number':
          return { color: 'var(--vjc-number-color)' };
        case 'boolean':
          return { color: 'var(--vjc-boolean-color)' };
        case 'object':
          return { color: 'var(--vjc-null-color)' };
        case 'undefined':
          return { color: 'var(--vjc-null-color)' };
        default:
          return { color: 'var(--vjc-valueKey-color)' };
      }
    }
  },
  computed: {
    classes: function(): object {
      return {
        'chevron-arrow': true,
        opened: this.open
      };
    },
    valueClasses: function(): object {
      return {
        'value-key': true,
        'can-select': this.canSelect
      };
    },
    lengthString: function(): string {
      if (this.data.type === 'array') {
        return this.data.length === 1
          ? this.data.length + ' element'
          : this.data.length + ' elements';
      }
      return this.data.length === 1
        ? this.data.length + ' property'
        : this.data.length + ' properties';
    },
    dataValue: function(): string {
      if (typeof this.data.value === 'undefined') {
        return 'undefined';
      }
      return JSON.stringify(this.data.value);
    }
  }
});
